import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainView from "./MainView";
import CitajteoCommon from "./CitajteoCommon";
import { AddNavigationProvider } from "common/modal/AddNavigation";
import CitajteoStart from "components/pages/common/CitajteoStart";
import AboutProject from "../pages/common/AboutProject";
import Copyright from "components/pages/common/Copyright";
import Artists from "components/pages/common/Artists";
import ArtisticMovementsAndPhenomena from "components/pages/common/ArtisticMovementsAndPhenomena";
import LoginView from "./LoginView";
import Login from "components/pages/authentication/Login";
import Logout from "components/pages/authentication/Logout";
import GroupIntroduction from "components/pages/dl_group/GroupIntroduction";
import GroupUTypeUnits from "components/pages/dl_group/GroupUTypeUnits";
import UnitSearch from "components/pages/UnitSearch/UnitSearch";
import AdmApp from "components/admin/AdmApp";
import AdminLayout from "../admin/layout/AdminLayout";
import UnitScan from "components/pages/unit/UnitScan";
import GroupPhotoSeries from "components/pages/photo_series/GroupPhotoSeries";
import GroupPhotoSeriesAlbum from "components/pages/photo_series/GroupPhotoSeriesAlbum";

export default function CitajteoMainContent() {
  return (
    <CitajteoCommon>
      <Router>
        <AddNavigationProvider>
          <Routes>
            <Route element={<MainView />}>
              <Route path="/" element={<CitajteoStart />} />
              <Route path="/about" element={<AboutProject />} />
              <Route path="/copyright" element={<Copyright />} />
              <Route path="/artists" element={<Artists />} />
              <Route
                path="/art-movements-and-phenomena"
                element={<ArtisticMovementsAndPhenomena />}
              />
              <Route path="/g">
                <Route path=":slug" element={<GroupIntroduction />}></Route>
                <Route
                  path=":slug/:uType"
                  element={<GroupUTypeUnits />}
                ></Route>
                <Route
                  path=":groupSlug/photo-series/:seriesType"
                  element={<GroupPhotoSeries />}
                ></Route>
                <Route
                  path="/g/:groupSlug/photo-series/:seriesType/:album"
                  element={<GroupPhotoSeriesAlbum />}
                />
              </Route>
              <Route path="/u">
                <Route path=":slug" element={<UnitScan />}></Route>
              </Route>
              <Route path="/search" element={<UnitSearch />} />
            </Route>
            <Route path="/admin-dashboard/*" element={<AdmApp />} />
            <Route element={<LoginView />}>
              <Route path="/l-in" element={<Login />} />
              <Route path="/l-out" element={<Logout />} />
            </Route>
          </Routes>
        </AddNavigationProvider>
      </Router>
    </CitajteoCommon>
  );
}
